const FieldTypes = {
    SHORT_TEXT: {
        id: 'SHORT_TEXT',
    },
    LONG_TEXT: {
        id: 'LONG_TEXT',
    },
    BOOLEAN: {
        id: 'BOOLEAN',
    },
    EMAIL: {
        id: 'EMAIL',
    },
    PHONE_NUMBER: {
        id: 'PHONE_NUMBER',
    },
    DATE: {
        id: 'DATE',
    },
    GENDER: {
        id: 'GENDER',
    },
    NATIONALITY: {
        id: 'NATIONALITY',
    },
    LANGUAGES: {
        id: 'LANGUAGES',
    },
    COUNTRY: {
        id: 'COUNTRY',
    },
    ROLES: {
        id: 'ROLES',
    },
    SKILLS: {
        id: 'SKILLS',
    },
    INDUSTRIES: {
        id: 'INDUSTRIES',
    },
    THEMES: {
        id: 'THEMES',
    },
    EDUCATION: {
        id: 'EDUCATION',
    },
    SMALL_NUMBER: {
        id: 'SMALL_NUMBER',
    },
    NUM_HACKATHONS: {
        id: 'NUM_HACKATHONS',
    },
    T_SHIRT_SIZE: {
        id: 'T_SHIRT_SIZE',
    },
    URL: {
        id: 'URL',
    },
    DIETARY_RESTRICTIONS: {
        id: 'DIETARY_RESTRICTIONS',
    },
    TEAM_OPTIONS: {
        id: 'TEAM_OPTIONS',
    },
    RECRUITMENT_OPTIONS: {
        id: 'RECRUITMENT_OPTIONS',
    },
}

module.exports = FieldTypes
